import React from 'react';
import { useTranslation } from 'react-i18next';
import ItmonkeysVideo from '../../../assets/videos/itmonkeys-nas.mp4';
import NasSynologyImage from '../../../assets/images/itmonkeys-nas-synology.png';
import CorporateImage from '../../../assets/images/itmonkeys-corporate.png';
import CloudImage from '../../../assets/images/openspaceazure.jpg';
import './IntroSectionPrivateCloud.css';

const IntroSectionPrivateCloud2: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="intro-section-home intro-section-private-cloud-2">
      {/* Video and Images Section */}
      <div className="intro-section">
        <div className="intro-row-1">
          <div className="intro-text-1">
            <h2>{t('privateCloud.introSection.remoteAdmin.title', 'Administration à distance')}</h2>
            <h3>{t('privateCloud.introSection.remoteAdmin.description', 'De l\'audit de vos besoins à la maintenance, en passant par la migration, nous gérons tout pour vous offrir une tranquillité d\'esprit totale. Nous faisons évoluer votre cloud privé au rythme de votre entreprise.')}</h3>
          </div>
          <div className="intro-image">
            <video
              className="intro-media"
              autoPlay
              loop
              muted
              playsInline
            >
              <source src={ItmonkeysVideo} type="video/mp4" />
              {t('privateCloud.video.notSupported', 'Votre navigateur ne supporte pas la balise vidéo.')}
            </video>
          </div>
        </div>

        <div className="intro-row-2">
          <div className="intro-text-2">
            <h2>{t('privateCloud.introSection.organizeData.title', 'Organisez vos données')}</h2>
            <h3>{t('privateCloud.introSection.organizeData.description', 'Dites adieu à la dispersion de vos données et aux infrastructures trop complexes ou mal organisées. Le cloud privé sur NAS que nous proposons chez IT Monkeys est la réponse à vos enjeux de sécurité, de flexibilité et de performance.')}</h3>
          </div>

          <div className="intro-image">
            <img
              className="intro-media"
              src={CorporateImage}
              alt={t('privateCloud.introSection.organizeData.imageAlt', 'Security')}
            />
          </div>
        </div>

        <div className="intro-bottom-home">
          <div className="intro-row-1">
            <div className="intro-text-1">
              <h2>{t('privateCloud.introSection.adaptedTech.title', 'Une technologie adaptée à vos besoins.')}</h2>
              <h3>{t('privateCloud.introSection.adaptedTech.description', 'Contrairement à un serveur traditionnel, le NAS est principalement focalisé sur la fonction de stockage, avec une interface de gestion souvent plus simple et des fonctionnalités préintégrées pour la sauvegarde, le partage, la sécurité et la synchronisation des données.')}</h3>
            </div>
            <div className="intro-image">
              <img
                src={CloudImage}
                loading="lazy"
                className="intro-media"
                alt={t('privateCloud.introSection.adaptedTech.imageAlt', 'Azure OpenAI')}
              />
            </div>
          </div>
        </div>

        <div className="intro-section-formation">
          <div className="centered-title-formation">
          </div>
        </div>
      </div>
    </div>
  );
};

export default IntroSectionPrivateCloud2;
